module.exports = __webpack_public_path__ + "public/images/slider/Muradyan-circle.822c0e5e333ee74eaf3e9b2e33b7892e.webp";